ACC.product = {

	bindAll: function ()
	{
		ACC.product.bindToAddToCartForm();
		ACC.product.bindToAddToCartStorePickUpForm();
		ACC.product.bindToAddToCartButton();
		ACC.product.bindToAddToCartCollectionForm();
		/*ACC.product.bindQuickViewPopup();*/
		// ACC.product.initQuickviewLightbox(); // this shouldn't be bound unless needed, this is an ongoing themem, there is also a repetition of the binding to the form
	},

	initQuickviewLightbox:function(){
		// this.enableAddToCartButton(); // this is done on the page itself
	//	Note: this binding is now correctlu being fired from the $.colorbox onComplete callnback
		this.bindToAddToCartForm();
	},
	
	bindToAddToCartForm: function ()
	{
		var addToCartForm = $('.add_to_cart_form');
		addToCartForm.ajaxForm({
			error: function() {
				debugger;
			},
			success: function( data, status, xhr ) {
				ACC.product.displayAddToCartPopup( data, status, xhr );
				twc.events.onAddToCartSuccess();
			}
		});
	},
	
	enableAddToCartButton: function ()
	{
		$('#addToCartButton').removeAttr("disabled");
	},
	
	bindToAddToCartButton: function ()
	{		
		$('#addToCartButton').removeAttr("disabled");
	},

	bindToAddToCartCollectionForm: function ()
	{
		var addToCartCollectionForm = $('.add_to_cart_collection_form');
		addToCartCollectionForm.ajaxForm({
			success: function( data, status, xhr ) {
				ACC.product.displayAddToCartPopup( data, status, xhr );
				twc.events.onAddToCartSuccess();
			}
		});
	},
	
	bindToAddToCartStorePickUpForm: function ()
	{
		var addToCartStorePickUpForm = $('.add_to_cart_storepickup_form');
		addToCartStorePickUpForm.ajaxForm({
			success: ACC.product.displayAddToCartPopup
		});
	},
	
	bindQuickViewPopup: function()
	{
		$("#quickViewLink").click(function() {
			ACC.product.handleQuickViewPopup();
		})
	},
	
	displayAddToCartPopup: function (cartResult, statusText, xhr, formElement)
	{
		var productCode = $('[name=productCodePost]', formElement).val();
		var quantityField = $('[name=qty]', formElement).val();
		var quantity = 1;
		if (quantityField != undefined)
		{
			quantity = quantityField;
		}

		ACC.product.trackAddToCart(productCode, quantity, cartResult.cartData);
		$('#cart_popup').hide();
		$('#cart_popup').html(cartResult.cartPopupHtml);

		$('#add_to_cart_close').click(function (e)
		{
			e.preventDefault();
			$('#cart_popup').hide();
		});

		if (typeof ACC.cartpopup.refreshMiniCart == 'function')
		{
			ACC.cartpopup.refreshMiniCart();
		}

		$('#cart_popup').fadeIn();
		if (typeof timeoutId != 'undefined')
		{
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(function ()
		{
			$('#cart_popup').fadeOut();
		}, 5000);
		$.colorbox.close();
	},

	trackAddToCart: function (productCode, quantity, cartData)
	{
		if (window.trackAddToCart_jirafe)
		{
			trackAddToCart_jirafe(cartData);
		}

		if (window.trackAddToCart_google)
		{
			trackAddToCart_google(productCode, quantity);
		}
	},
	
	handleQuickViewPopup : function() {
		
		// Show the delivery address popup
		$.colorbox({
			inline : true,
			href : "#popup_quickView_product",
			overlayClose : false,			
			onOpen : function() {
				
				ACC.product.quickViewDisplay();
				
			},
			onComplete : function() {
				ACC.common.refreshScreenReaderBuffer();
				$.colorbox.resize();
			},
			onClosed : function() {
				ACC.common.refreshScreenReaderBuffer();
			}
		});
	},
	
	quickViewDisplay : function() {
		var options = {
			url : getDeliveryAddressFormUrl,
			data : {
				addressId : '',
				createUpdateStatus : ''
			},
			type : 'GET',
			success : function(data) {
				$('#create_update_address_form_container_div').html(data);
				ACC.address.bindCreateUpdateAddressForm();
			}
		};

		$.ajax(options);
	}

};

$(document).ready(function ()
{
	ACC.product.bindAll();
});

